export default __webpack_public_path__ + "static/media/Pencil.ad3e7774.svg";